module.exports = __webpack_public_path__ + "img/upload_image.e8cbd62f.svg";